

import { useState, useEffect } from "react";
import brand from "assets/images/logo.png";
// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard React examples
import DefaultNavbarLink from "examples/Navbars/DefaultNavbar/DefaultNavbarLink";
import DefaultNavbarMobile from "examples/Navbars/DefaultNavbar/DefaultNavbarMobile";

// Soft UI Dashboard React base styles
import breakpoints from "assets/theme/base/breakpoints";
import { Card } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

function DefaultNavbar({ transparent, light, action, currentStep }) {
	const [mobileNavbar, setMobileNavbar] = useState(false);
	const [mobileView, setMobileView] = useState(false);

	const openMobileNavbar = ({ currentTarget }) => setMobileNavbar(currentTarget.parentNode);
	const closeMobileNavbar = () => setMobileNavbar(false);

	useEffect(() => {
		// A function that sets the display state for the DefaultNavbarMobile.
		function displayMobileNavbar() {
			if (window.innerWidth < breakpoints.values.lg) {
				setMobileView(true);
				setMobileNavbar(false);
			} else {
				setMobileView(false);
				setMobileNavbar(false);
			}
		}

		/** 
		 The event listener that's calling the displayMobileNavbar function when 
		 resizing the window.
		*/
		window.addEventListener("resize", displayMobileNavbar);

		// Call the displayMobileNavbar function to set the state with the initial value.
		displayMobileNavbar();

		// Remove event listener on cleanup
		return () => window.removeEventListener("resize", displayMobileNavbar);
	}, []);

	return (
		<Container 
				borderRadius="0px"
		
		>
			<SoftBox
				// py={1.5}
				// px={{ xs: transparent ? 2 : 3, sm: transparent ? 2 : 4, lg: transparent ? 2 : 5 }}
				mt={3}
				className="glassmorphism-card"
				width="100%"
				borderRadius="16px"
				boxShadow={transparent ? "none" : "0 8px 30px rgba(0, 0, 0, 0.12)"}
				color={light ? "white" : "dark"}
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				zIndex={3}
				sx={({ palette: { transparent: transparentColor, white }, functions: { rgba } }) => ({
					backgroundColor: transparent ? transparentColor.main : rgba(white.main, 0.75),
					backdropFilter: transparent ? "none" : `saturate(180%) blur(20px)`,
					border: transparent ? "none" : "1px solid rgba(255,255,255,0.2)",
				})}
			>
				{/* Logo */}
				<SoftBox
					component={Link}
					to="/"
					// py={transparent ? 1.5 : 0.75}
					// lineHeight={1}
					display="flex"
					alignItems="center"
					justifyContent="center"
					mb={1}
				>
					{brand && (
						<SoftBox component="img" src={brand} alt="Logo" width="7rem" sx={{ filter: light ? "brightness(100%)" : "brightness(60%)" }} />
					)}
				</SoftBox>

				{/* Step Info */}
				<SoftTypography
					variant="h6"
					fontWeight="medium"
					color={light ? "#fff" : "text"}
					mb={0.5}
				>
					Step {currentStep} of 3
				</SoftTypography>

				{/* Progress Line */}
				<SoftBox display="flex" width="90%">
					{Array.from({ length: 3 }).map((_, index) => (
						<SoftBox
							key={index}
							height="6px"
							width="90%"
							mx={0.5}
							borderRadius="0px"
							bgColor={index < currentStep ? "info" : "grey-300"}
							sx={{
								transition: "all 0.4s ease",
								boxShadow: index < currentStep ? "0 0 5px rgba(0, 172, 255, 0.5)" : "none",
								overflow: "overlay"
							}}
						/>
					))}
				</SoftBox>
			</SoftBox>
			{mobileView && <DefaultNavbarMobile open={mobileNavbar} close={closeMobileNavbar} />}
		</Container>
	);
}

// Setting default values for the props of DefaultNavbar
DefaultNavbar.defaultProps = {
	transparent: false,
	light: false,
	action: false,
};

// Typechecking props for the DefaultNavbar
DefaultNavbar.propTypes = {
	transparent: PropTypes.bool,
	light: PropTypes.bool,
	action: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.shape({
			type: PropTypes.oneOf(["external", "internal"]).isRequired,
			route: PropTypes.string.isRequired,
			color: PropTypes.oneOf([
				"primary",
				"secondary",
				"info",
				"success",
				"warning",
				"error",
				"dark",
				"light",
			]),
			label: PropTypes.string.isRequired,
		}),
	]),
};

export default DefaultNavbar;
